import { render, staticRenderFns } from "./bottomButtons.vue?vue&type=template&id=6ba1a3d7&scoped=true&"
import script from "./bottomButtons.vue?vue&type=script&lang=js&"
export * from "./bottomButtons.vue?vue&type=script&lang=js&"
import style0 from "./bottomButtons.vue?vue&type=style&index=0&id=6ba1a3d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba1a3d7",
  null
  
)

export default component.exports